import hdrm from '../../hdrm';
import template from '../../template';
import { connectedStore } from '../../store';

const getMappedPageContainer = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const pageContainerSelector = template.selectors.getPageContainerSelector(state);

  const liveDocument = hdrm.instance.driver.getLiveDocument();
  const pageContainer = liveDocument.querySelector(pageContainerSelector);

  return pageContainer ? new XMLSerializer().serializeToString(pageContainer) : '';
};

export default getMappedPageContainer;
